export default __webpack_public_path__ + "static/media/026-sloth.836f1c0c.svg";